import React from 'react';
import FormTextField from 'views/EMR/components/FillableForm/components/FormTextField';
import {
  FieldComponentProps,
} from 'views/EMR/components/FillableForm/types';
import {
  placeholderByType,
} from 'views/EMR/components/FillableForm/utils/fieldPositioning';

export default function ShortText({
  field,
  value,
  onChange,
  error,
}: FieldComponentProps) {
  const placeholder = placeholderByType[field.type] ?? 'Please enter a value';
  return (
    <FormTextField
      id={field?.id ?? ''}
      key={field?.id}
      autoFocus
      fullWidth
      error={error}
      placeholder={placeholder}
      value={(value?.value ?? '') as string}
      slotProps={{ htmlInput: { maxLength: 64 } }}
      onChange={(e) => {
        onChange?.({ ...value, value: e.target.value });
      }}
    />
  );
}
